import { render, staticRenderFns } from "./NewMedia.vue?vue&type=template&id=0bf85fbc"
import script from "./NewMedia.vue?vue&type=script&lang=js"
export * from "./NewMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports